import latoBold from "./assets/fonts/Lato-Bold.woff2";
import latoExtraBold from "./assets/fonts/Lato-ExtraBold.woff2";
import latoLight from "./assets/fonts/Lato-Light.woff2";
import latoMedium from "./assets/fonts/Lato-Medium.woff2";
import latoRegular from "./assets/fonts/Lato-Regular.woff2";
import latoSemiBold from "./assets/fonts/Lato-SemiBold.woff2";
import montserratBold from "./assets/fonts/Montserrat-Bold.woff2";
import montserratExtraBold from "./assets/fonts/Montserrat-ExtraBold.woff2";
import montserratMedium from "./assets/fonts/Montserrat-Medium.woff2";

const faces = [
  ["Lato", 300, latoLight],
  ["Lato", 400, latoRegular],
  ["Lato", 500, latoMedium],
  ["Lato", 600, latoSemiBold],
  ["Lato", 700, latoBold],
  ["Lato", 800, latoExtraBold],
  ["Montserrat", 500, montserratMedium],
  ["Montserrat", 700, montserratBold],
  ["Montserrat", 800, montserratExtraBold]
] as const;

export const brandFontFaces = faces
  .map(
    ([family, weight, url]) => `@font-face {
      font-family: '${family}';
      font-style: normal;
      font-weight: ${weight};
      font-display: swap;
      src: url('${url}') format('woff2');
    }`
  )
  .join("\n");
